import JsonRPCService from './JsonRPCService';

export default angular.module('edge.platform.jsonrpc', ['gw-portals-transport-angular']).factory('JsonRPCService', JsonRPCService);


//////////////////
// WEBPACK FOOTER
// ./common/js/src/edge/platform/jsonrpc/module.js
// module id = 1908
// module chunks = 0